import React, { Component } from "react"
import Select from "../../../components/Select"
import auth from "../../../utils/auth"

class General extends Component {
    isCustomer = auth.isClient()

    handleChange = (field, value) => {
        const detalhes = Object.assign({}, this.props.detalhes)
        const errors = Object.assign({}, this.props.errors)

        detalhes[field] = value

        if(field === "region") {
            let optionsSelect = Object.assign({}, this.props.optionsSelect)
            optionsSelect["region_config_id"] = value.region_config_id
            this.props.setOptionsSelect(optionsSelect)
        }

        if(field in errors) {
            delete errors[field]
            this.props.setErrors(errors)
        }

        this.props.setDetalhes(detalhes)
    }

    render() {
        const { detalhes, optionsSelect, errors, optionsCliente, edit, isTemplate, lockedClienteId } = this.props

        return (
            <div className="hdv-form-default">

                <div className="row">
                    {!isTemplate &&
                    <div className="col-md-12">
                        <label className="required">Cliente</label>
                        <Select
                            options={optionsCliente}
                            value={detalhes.cliente}
                            disabled={this.isCustomer || lockedClienteId !== undefined}
                            onChange={(e) => this.handleChange("cliente", e)}
                        />
                    </div>
                    }
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="name" title="Nome">Nome</label>
                        <input
                            type='text'
                            value={detalhes.name ?? ""}
                            id="name"
                            onChange={(e) => this.handleChange("name", e.target.value)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-name'>{ errors["name"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className='required' htmlFor="description" title="Descrição">Descrição</label>
                        <input
                            type='text'
                            value={detalhes.description ?? ""}
                            id="description"
                            onChange={(e) => this.handleChange("description", e.target.value)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-description'>{ errors["description"] ?? ""  }</span>
                    </div>
                </div>

                
                <div className="row">
                    <div className="col-md-6">
                        <label className="required" title="Região">Região</label>
                        <Select
                            options={optionsSelect.region}
                            value={detalhes.region}
                            onChange={(e) => this.handleChange("region", e)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-region'>{ errors["region"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className='required' title="Configuração de Região">Configuração de Região</label>
                        <Select
                            options={optionsSelect.region_config_id}
                            value={detalhes.region_config_id}
                            onChange={(e) => this.handleChange("region_config_id", e)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-region_config_id'>{ errors["region_config_id"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" title="Versão MAC">Versão MAC</label>
                        <Select
                            options={optionsSelect.mac_version}
                            value={detalhes.mac_version}
                            onChange={(e) => this.handleChange("mac_version", e)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-mac_version'>{ errors["mac_version"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className='required' title="Revisão de Parâmetros Regionais">Revisão de Parâmetros Regionais</label>
                        <Select
                            options={optionsSelect.reg_params_revision}
                            value={detalhes.reg_params_revision}
                            onChange={(e) => this.handleChange("reg_params_revision", e)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-reg_params_revision'>{ errors["reg_params_revision"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-12">
                        <label className="required" title="Algoritmo ADR">Algoritmo ADR</label>
                        <Select
                            options={optionsSelect.adr_algorithm_id}
                            value={detalhes.adr_algorithm_id}
                            onChange={(e) => this.handleChange("adr_algorithm_id", e)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-adr_algorithm_id'>{ errors["adr_algorithm_id"] ?? ""  }</span>
                    </div>
                </div>

                <div className="row">
                    <div className="col-md-6">
                        <label className="required" htmlFor="flush_queue_on_activate" title="Liberar fila ao ativar">Liberar fila ao ativar</label>
                        <input
                            type='checkbox'
                            checked={detalhes.flush_queue_on_activate}
                            id="flush_queue_on_activate"
                            onChange={(e) => this.handleChange("flush_queue_on_activate", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-flush_queue_on_activate'>{ errors["flush_queue_on_activate"] ?? ""  }</span>
                    </div>
                    <div className="col-md-6">
                        <label className="required" htmlFor="allow_roaming" title="Permitir roaming">Permitir roaming</label>
                        <input
                            type='checkbox'
                            checked={detalhes.allow_roaming}
                            id="allow_roaming"
                            onChange={(e) => this.handleChange("allow_roaming", e.target.checked)}
                            disabled={isTemplate}
                        />
                        <span id='validacao-allow_roaming'>{ errors["allow_roaming"] ?? ""  }</span>
                    </div>
                </div>



                <div className="row">
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="uplink_interval" title="Intervalo de uplink esperado (segundos)">Intervalo de uplink esperado (segundos)</label>
                        <input
                            type='text'
                            value={detalhes.uplink_interval ?? ""}
                            id="uplink_interval"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("uplink_interval", value)
                            }}
                            disabled={isTemplate}
                        />
                        <span id='validacao-uplink_interval'>{ errors["uplink_interval"] ?? ""  }</span>
                    </div>
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="device_status_req_interval" title="Frequência de solicitação do Dispositivo-Status (req/dia)">Frequência de solicitação do Dispositivo-Status (req/dia)</label>
                        <input
                            type='text'
                            value={detalhes.device_status_req_interval ?? ""}
                            id="device_status_req_interval"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("device_status_req_interval", value)
                            }}
                            disabled={isTemplate}
                        />
                        <span id='validacao-device_status_req_interval'>{ errors["device_status_req_interval"] ?? ""  }</span>
                    </div>
                    <div className="col-md-4">
                        <label className="required label-truncate" htmlFor="rx1_delay" title="Atraso RX1 (0 = usar padrão do sistema)">Atraso RX1 (0 = usar padrão do sistema)</label>
                        <input
                            type='text'
                            value={detalhes.rx1_delay ?? ""}
                            id="rx1_delay"
                            onChange={(e) => {
                                let value = e.target.value.replace(/[.,e]/g, "")
                                value = value ? parseInt(value) : 0
                                this.handleChange("rx1_delay", value)
                            }}
                            disabled={isTemplate}
                        />
                        <span id='validacao-rx1_delay'>{ errors["rx1_delay"] ?? ""  }</span>
                    </div>
                </div>

            </div>
        )
    }
}

export default General